import { Switch } from 'react-router-dom';
import { useAddresses } from 'contexts/AddressContext';
import { useCompany } from 'contexts/CompanyContext';
import { useEmployee } from 'contexts/EmployeeContext';
import { useProvider } from 'contexts/ProviderContext';
import { SocialNetworksProvider } from 'contexts/SocialNetworksContext';
import LoadingBackdrop from 'components/LoadingBackdrop';
import MainArea from './MainArea';
import PrivateRoute from 'routes/PrivateRoute';
import RegisterArea from './RegisterArea';
import routes from 'config/routes';
import End from './RegisterArea/End';

const SocialNetworkContext = ({ children }) => {
  const { addressesLoading } = useAddresses();
  const { companiesLoading, companyDetailsLoading } = useCompany();
  const { employeesLoading } = useEmployee();
  const { providerLoading } = useProvider();

  if (addressesLoading || companiesLoading || employeesLoading || providerLoading || companyDetailsLoading)
    return <LoadingBackdrop size={100} />

  return (
    <SocialNetworksProvider>
      {children}
    </SocialNetworksProvider>
  );
}

function SecuredArea() {
  return (
    <SocialNetworkContext>
      <Switch>
        <PrivateRoute path={routes.end.root}>
          <End />
        </PrivateRoute>

        <PrivateRoute path={routes.register.root}>
          <RegisterArea />
        </PrivateRoute>

        <MainArea />
      </Switch>
    </SocialNetworkContext>
  );
}

export default SecuredArea;
